import { Link } from "react-router-dom";
import { Button } from "../ui/Button";
import { useHeader } from "./hook/useHeader";

export default function Header() {
    const {
        openHeader,
        toggleOpenHeader,
        navigate,
        user,
        handleLoginClick,
        handleLogoutClick
    } = useHeader()

    return (
        <header className="w-full bg-white shadow z-50 absolute">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-between h-16">
                <div className="flex items-center">
                    <img
                        onClick={() => navigate('/')}
                        src="/assets/logo-lojao-bmg.png"
                        alt="Banco BMG"
                        className="h-9 sm:h-14 hover:cursor-pointer"
                    />
                </div>

                <nav className="hidden md:flex space-x-6 text-sm font-medium text-gray-700">
                    <Link to='/emprestimo-consignado' className="cursor-pointer hover:text-orange-600" >Consignado INSS</Link>
                    <Link to='/saque-cartao' className="cursor-pointer hover:text-orange-600" >Saque no cartão</Link>
                    <Link to='/cartao-beneficio' className="cursor-pointer hover:text-orange-600">Cartão Benefício</Link>
                    <Link to='/seguro' className="cursor-pointer hover:text-orange-600">Seguro</Link>
                    <Link to='/saque-fgts' className="cursor-pointer hover:text-orange-600">FGTS</Link>
                </nav>

                <div className="hidden md:flex gap-2">
                    {!user
                        ? <Button onClick={() => navigate('/login')} variant="secondary">
                            Entrar
                        </Button>
                        : <Button onClick={() => navigate('/dashboard')} variant="secondary">
                            Entrar
                        </Button>
                    }
                    {!user
                        ? <Button onClick={() => navigate('/register')} >
                            Cadastrar-se
                        </Button>
                        : null
                    }
                </div>


                <div className="md:hidden">
                    <button
                        onClick={() => toggleOpenHeader()}
                        className="text-gray-700 focus:outline-none"
                    >
                        <svg
                            className="w-6 h-6"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                        >
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                        </svg>
                    </button>
                </div>
            </div>

            <div
                className={`fixed inset-0 z-50 bg-white transform transition-transform duration-300 ease-in-out ${openHeader ? "translate-x-0" : "-translate-x-full"
                    }`}
            >
                <div className="flex justify-between items-center px-4 py-4 border-b shadow">
                    <img
                        src="/assets/logo-bmg.svg"
                        alt="Banco BMG"
                        className="h-6" />
                    <button
                        onClick={() => toggleOpenHeader()}
                        className="text-gray-700"
                    >
                        <svg
                            className="w-6 h-6"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                        >
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                        </svg>
                    </button>
                </div>

                <nav className="flex flex-col px-6 py-4 space-y-4 text-base font-medium text-gray-700">
                    <a a href="#" className="hover:text-orange-600" > Empréstimo CLT</a>
                    <a href="#" className="hover:text-orange-600">FGTS</a>
                    <a href="#" className="hover:text-orange-600">INSS</a>
                    <a href="#" className="hover:text-orange-600">PIX</a>
                    <a href="#" className="hover:text-orange-600">Utilidades</a>
                    <a href="#" className="hover:text-orange-600">Sobre</a>
                    <a href="#" className="hover:text-orange-600">Blog</a>

                    <Button>
                        Contrate agora
                    </Button>

                    {!user ?
                        <Button onClick={handleLoginClick} variant="secondary">
                            Entrar
                        </Button>
                        : <Button onClick={handleLogoutClick} variant="secondary">
                            Sair
                        </Button>
                    }
                    {!user?
                        <Button onClick={() => navigate('/register')}>
                            Cadastrar-se
                        </Button>
                        : null
                    }
                </nav>
            </div>
        </header>
    );
}
